/**
 * RTL-aware scroll helpers shared by the theme's horizontal-scrolling
 * carousels. Centralizes the cross-browser scrollLeft sign/zero-point
 * handling that differs under dir="rtl" between browser engines, so each
 * carousel doesn't reimplement (and potentially get wrong) its own version.
 */
window.themeRTL = (function () {
  function isRTL(el) {
    var element = el || document.documentElement;
    return getComputedStyle(element).direction === 'rtl';
  }

  // amount > 0 always means "forward" (toward the next item in reading
  // order), regardless of direction.
  function scrollByAmount(el, amount, behavior) {
    var delta = isRTL(el) ? -amount : amount;
    el.scrollBy({ left: delta, behavior: behavior || 'smooth' });
  }

  // Normalizes el.scrollLeft to a consistent 0 (start) -> max (end) range
  // regardless of whether the engine reports RTL scrollLeft as negative
  // (Firefox / spec-compliant Chromium) or reverse-indexed from
  // scrollWidth (older WebKit / legacy Chromium "default" model).
  function normalizedScrollLeft(el) {
    var value = el.scrollLeft;
    if (!isRTL(el)) return value;
    if (value <= 0) return Math.abs(value);
    return (el.scrollWidth - el.clientWidth) - value;
  }

  return {
    isRTL: isRTL,
    scrollByAmount: scrollByAmount,
    normalizedScrollLeft: normalizedScrollLeft
  };
})();
